import { render, staticRenderFns } from "./CourseCardNew.vue?vue&type=template&id=03a3f15d&scoped=true&"
import script from "./CourseCardNew.vue?vue&type=script&lang=js&"
export * from "./CourseCardNew.vue?vue&type=script&lang=js&"
import style0 from "./CourseCardNew.vue?vue&type=style&index=0&id=03a3f15d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a3f15d",
  null
  
)

export default component.exports